import { render, staticRenderFns } from "./FourMatText4.vue?vue&type=template&id=81794606&scoped=true&"
var script = {}
import style0 from "./FourMatText4.vue?vue&type=style&index=0&id=81794606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81794606",
  null
  
)

export default component.exports